import React, { Component, PropTypes } from 'react';
// import CornerLabel from '../../components/block/cornerLabel';

import css from './content.scss';

export default class AccountBlockContent extends Component {
	static propTypes = {
		title: PropTypes.oneOfType([
			PropTypes.string,
			React.PropTypes.object,
		]),
		sticky: PropTypes.bool.isRequired,
		browser: PropTypes.oneOfType([
			React.PropTypes.object,
			React.PropTypes.oneOf([false]),
		]).isRequired,
		smallAside: PropTypes.bool,
		style: PropTypes.object,
	};

	static defaultProps = {
		title: '',
		className: '',
		sticky: false,
		browser: false,
		smallAside: false,
		style: {},
	};

	constructor(props) {
		super();

		this.headerHeight = 0;
		this.offsetTop = 0;

		this.getStickyStyle = this.getStickyStyle.bind(this);

		if (props.sticky && !props.browser) {
			console.warn('Sticky header needs browser props.');
		}

		this.state = {
			stickyStyle: {},
		};
	}

	componentWillMount() {
		if (this.props.sticky && this.props.browser) {
			this.props.browser.scroll.register(this.getStickyStyle);
		}

	}

	componentWillUnmount() {
		if (this.props.sticky && this.props.browser) {
			this.props.browser.scroll.deregister(this.getStickyStyle);
		}
	}

	render() {
		let mainClass = 'account-block-content';
		let containerClass = mainClass;
		let stickyClass = (this.props.sticky) ? mainClass + '__sticky span14' : '';
		let asideClass = 'span5 span5-tablet span14-mobile account-block-content__aside';
		let contentClass = 'span9 span100p-tablet span100p-mobile account-block-content__content';

		if (this.props.sticky) {
			containerClass += ' account-block-content--fixed-height account-block-content--title-head';
			contentClass = 'span9 span9-tablet span100p-mobile account-block-content__content';
		}

		if (this.props.className) {
			containerClass += ' ' + this.props.className;
		}

		if (this.props.smallAside) {
			containerClass += ' account-block-content--small-aside';
			asideClass = 'span3 span12-tablet span10-mobile account-block-content__aside';
		}

		if (!this.props.title) {
			asideClass += ' account-block-content__aside--no-content';
		}

		return (
			<div className={containerClass} ref='mainElement' style={this.props.style}>
				<div className={stickyClass} ref='stickyElement' style={this.state.stickyStyle}>
					<aside className={asideClass} ref='asideElement' style={this.state.asideStyle}>{this.props.title}</aside>
					<div className={contentClass} ref='contentElement'>
						{this.props.children}
					</div>
					<div className='cf'></div>
				</div>
			</div>
		);
	}

	getStickyStyle(e) {
		if (e.scrollY === this.prevSrollY) {
			return false; // noop
		} else {
			this.prevSrollY = e.scrollY;
		}

		let newState = { ...this.state };
		let headerHeight = this.headerHeight = (!this.headerHeight) ? document.querySelector('.header-main').offsetHeight : this.headerHeight;
		let mainOffsetTop = this.offsetTop = (!this.offsetTop && this.refs.mainElement) ? this.refs.mainElement.offsetTop : this.offsetTop;
		let mainHeight = this.offsetHeight = (!this.offsetHeight && this.refs.mainElement) ? this.refs.mainElement.offsetHeight : this.offsetHeight;

		let distanceToMenu = (mainOffsetTop - headerHeight);
		let isSticky = (e.scrollY >= distanceToMenu);

		newState.stickyStyle = this.getStickyElementStickyStyle(e, distanceToMenu, mainHeight, headerHeight);
		newState.asideStyle = this.getAsideElementStickyStyle(e, distanceToMenu, mainHeight, headerHeight);
		this.setState(newState);
	}

	getStickyElementStickyStyle(e, distanceToMenu, mainHeight, headerHeight) {
		let minHeight = 77;
		let isMobile = (this.props.browser.window.width <= 719);
		let scrollY = e.scrollY;
		let asideHeight = 0;

		if (isMobile) {
			let compStyle = window.getComputedStyle(this.refs.asideElement);
			asideHeight = (
				this.refs.asideElement.offsetHeight +
				(parseInt(compStyle.marginTop, 10) || 0) +
				(parseInt(compStyle.marginBottom, 10) || 0)
			);

			scrollY -= asideHeight;
		}

		let isSticky = (scrollY >= distanceToMenu);

		if (isSticky) {
			let newHeight = (mainHeight + distanceToMenu) - scrollY;

			newHeight = (newHeight > mainHeight) ? mainHeight : (
				(newHeight < minHeight) ? minHeight : newHeight
			);

			return {
				position: 'fixed',
				top: (isMobile ? (headerHeight - asideHeight) : headerHeight) + 'px',
				height: (isMobile ? mainHeight : newHeight) + 'px',
			};
		}

		return {};
	};

	getAsideElementStickyStyle(e, distanceToMenu, mainHeight) {
		let scrollY = e.scrollY;
		let progress = scrollY - distanceToMenu;

		// limit to our heights
		progress = (progress > mainHeight) ? mainHeight : (
			(progress < 0) ? 0 : progress
		);

		// convert to percentage
		progress = 1 - ((1 / mainHeight) * progress);

		return {
			opacity: progress,
		};
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/account/block/content.js
 **/